import { render, staticRenderFns } from "./splitOrderDialog.vue?vue&type=template&id=eca9c65a&scoped=true"
import script from "./splitOrderDialog.vue?vue&type=script&lang=js"
export * from "./splitOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./splitOrderDialog.vue?vue&type=style&index=0&id=eca9c65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca9c65a",
  null
  
)

export default component.exports